import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ClientLayoutWithOutHeader from "../../client/components/layout/ClientLayoutWithOutHeader";
import PopupConfirmation from "../../client/third-party-casino/popup-confirmation";
import { useNavigate, Link } from "react-router-dom";
import axiosInstance from "../../../utils/axiosInstance";

export default function MultiCasino() {
  const [balance, setBalance] = useState(0);
  const [username, setUsername] = useState("");
  const [expouser, setExpouser] = useState(0);
  const [launchURL, setLaunchURL] = useState("");
  const [allImagesList, setAllImagesList] = useState([]);
  const [displayImageList, setDisplayImageList] = useState([]);

  const userInfo = useSelector((state) => state.userStore);
  const [activeTab, setActiveTab] = useState("Home");

  const showHideDiv = (tabName) => {
    if (
      allImagesList != null &&
      allImagesList !== "" &&
      allImagesList.length > 0
    ) {
      if (tabName == "Home") {
        setDisplayImageList(allImagesList);
      } else {
        const filtered = allImagesList.filter((obj) => obj.tab == tabName);
        setDisplayImageList(filtered);
      }
    }
    setActiveTab(tabName);
  };

  useEffect(() => {
    setUsername(userInfo.data.uname);
    setBalance(parseInt(userInfo.data.bz_balance));
    setExpouser(parseInt(userInfo.data.opin_bal - userInfo.data.bz_balance));
    //}
  }, [userInfo, setUsername, setExpouser, setBalance]);

  const callBackend = async () => {
    let postData = JSON.stringify({
      providerCode: ""
    });

    try {
      const response = await axiosInstance.post(
        "/th-casino/all-images",
        postData
      );

      setAllImagesList(response.data.data);
      setDisplayImageList(response.data.data);
    } catch (error) {
      console.error("Error updating password:", error);
    } finally {
    }
  };

  useEffect(() => {
    callBackend();
  }, []);

  function ImageCard({ imagePath, title }) {
    const [visible, setVisible] = useState(true);

    if (!visible) return null;

    return (
      <div class="image-container">
        <img
          src={`../assets/casino_images/${imagePath}`}
          alt={title}
          onError={() => setVisible(false)}
        />
        <h5 class="card-title" style={{ color: "white" }}>
          {title}
        </h5>
      </div>
    );
  }

  return (
    <ClientLayoutWithOutHeader showLoader={false}>
      <style>{`  
          .home-section {
            position: relative;
            height: 100vh;
            left: 0; 

            width: calc(100% - 0px);
            transition: all 0.1s ease;
        }  
        .tabs {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          box-sizing: border-box;
      }
      .tab-button {
        cursor: pointer;
        background-color: #f0f0f0;
        border: 1px solid #ccc;
        flex-grow: 1;
        margin: 5px;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 10px;
        min-width: 130px;
        max-width: 130px;
    }
    .tab-button span {
      text-align: center;
      font-size: 16px;
      white-space: normal;
  }

    .bg-dream {
      background-image: url('/assets/images/dreambg.jpg');
      background-repeat: no-repeat;
      background-size: cover;
      background-attachment: fixed;
  }
 
  @media screen and (max-width: 850px) {
    .tab-button i {
      font-size: 15px;
      margin-bottom: 5px;
  }
    .tab-button {
        cursor: pointer;
        background-color: #f0f0f0;
        border: 1px solid #ccc;
        flex-grow: 1;
        margin: 5px;
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 3px;
        min-width: 70px;
        max-width: 80px;
    }
    .tab-button span {
      text-align: center;
      font-size: 10px;
      white-space: normal;
  } 
}
.image-container {
  margin: 10px;
  text-align: center;
}

.tab-content {
place-content: center;
align-items: center;
flex-flow: row;
flex-direction: row;
flex-wrap: wrap;
align-content: center;
justify-content: center;
}
.card-title {
  margin-bottom: .75rem;
}
.image-container img {
  max-width: 200px;
  min-width: 200px;
  max-height: 150px;
  min-height: 150px;
  height: auto;
}
h5 {
  font-size: 1rem;
}
.tab-content {
  margin-top: -1px;
  /* background: #fff; */
  border: 1px solid #c8ced3;
  background-image: url(/assets/images/dreambg.jpg)
}

`}</style>
      <section class="home-section">
        <div class="bodyheight">
          <div className="bg-dream">
            <div class="tabs">
              <div class="tab-button" onClick={() => showHideDiv("Home")}>
                <i class="fas fa-home"></i>
                <span>Home</span>
              </div>

              <div
                class="tab-button"
                onClick={() => showHideDiv("EvolutionGaming")}
              >
                <i class="fas fa-home"></i>
                <span>Evolution Gaming</span>
              </div>
              <div class="tab-button" onClick={() => showHideDiv("Ezugi")}>
                <i class="fas fa-home"></i>
                <span>Ezugi</span>
              </div>
              <div class="tab-button" onClick={() => showHideDiv("InstantWin")}>
                <i class="fas fa-home"></i>
                <span>Instant Win</span>
              </div>
              <div class="tab-button" onClick={() => showHideDiv("Ludo")}>
                <i class="fas fa-home"></i>
                <span>Ludo</span>
              </div>
              <div class="tab-button" onClick={() => showHideDiv("Slots")}>
                <i class="fas fa-home"></i>
                <span>Slots</span>
              </div>
              <div class="tab-button" onClick={() => showHideDiv("PowerGames")}>
                <i class="fas fa-home"></i>
                <span>Power Games</span>
              </div>
              <div
                class="tab-button"
                onClick={() => showHideDiv("RoyalGamingVirtual")}
              >
                <i class="fas fa-home"></i>
                <span>Royal Gaming Virtual</span>
              </div>
              <div
                class="tab-button"
                onClick={() => showHideDiv("RoyalGaming")}
              >
                <i class="fas fa-home"></i>
                <span>Royal Gaming</span>
              </div>
              <div class="tab-button" onClick={() => showHideDiv("Pragmatic")}>
                <i class="fas fa-home"></i>
                <span>Pragmatic Play</span>
              </div>
              <div class="tab-button" onClick={() => showHideDiv("Supernowa")}>
                <i class="fas fa-home"></i>
                <span>Supernowa</span>
              </div>
              <div class="tab-button" onClick={() => showHideDiv("OnlyPlay")}>
                <i class="fas fa-home"></i>
                <span>Only Play</span>
              </div>
              <div class="tab-button" onClick={() => showHideDiv("Spribe")}>
                <i class="fas fa-home"></i>
                <span>Spribe</span>
              </div>
              <div class="tab-button" onClick={() => showHideDiv("JiLi")}>
                <i class="fas fa-home"></i>
                <span>JiLi Lobby</span>
              </div>
              <div
                class="tab-button"
                onClick={() => showHideDiv("RoyalGamingLobby")}
              >
                <i class="fas fa-home"></i>
                <span>Royal Gaming Lobby</span>
              </div>
              <div
                class="tab-button"
                onClick={() => showHideDiv("EvolutionLobby")}
              >
                <i class="fas fa-home"></i>
                <span>Evolution Lobby</span>
              </div>
            </div>
          </div>
          <div className="bg-dream" style={{ height: "100vh", width: "100%" }}>
            <div class="tab-content tab" style={{ display: "flex" }}>
              {displayImageList &&
                displayImageList.length > 0 &&
                displayImageList?.map((item, index) => (
                  <Link
                    to={`/multi-casino-open/${item.code}/${item.game_code}`}
                  >
                    <ImageCard
                      key={index}
                      imagePath={item.image_name}
                      title={item.game_name}
                    />
                  </Link>
                ))}
            </div>

            <iframe
              class="iframetemplate"
              src={launchURL}
              style={{ width: "100%", height: "100vh", border: "0px" }}
            ></iframe>
          </div>
        </div>
      </section>
    </ClientLayoutWithOutHeader>
  );
}
